export enum EntitySourceType {
  CLIENT = "client",
  OPERATIONAL = "operational",
  OLD = "old"
}
